'use client';

import React from 'react';
import styles from '../styles/Home.module.css';

export default function Page() {
    return (
        <>
            <main className={styles.main} data-lk-theme="default">
                <div className="header">
                    Optiwork Call Frontend
                </div>
            </main>
        </>
    );
}
